import React from 'react';
import { Outlet, matchPath, useLocation, } from 'react-router-dom';
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import { useState } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Link,
  Box,
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination
} from '@mui/material';
// components
import Page from '../../components/Page';
import { SubMenus, TopRightTools } from '../MyComponents'

export default function SetLayout() {

  const [tools, setTools] = useState([]);

  const subMenus = [
    {
      title: '子账号',
      icon: 'ic:round-supervisor-account',
      path: '/dashboard/set/account'
    },
    {
      title: '授权记录',
      icon: 'whh:authentication',
      path: '/dashboard/set/authorization'
    },
    // {
    //   title: '收款方式',
    //   icon: 'whh:authentication',
    //   path: '/dashboard/set/payment'
    // },
    {
      title: '积分参数',
      icon: 'whh:authentication',
      path: '/dashboard/set/integralrule'
    },
    {
      title: '通道管理',
      // icon: 'whh:authentication',
      path: '/dashboard/set/door'
    },
    {
      title: '商户管理',
      // icon: 'whh:authentication',
      path: '/dashboard/set/shanghu'
    }
  ]

  return (
    <Page title="Set | Minimal-UI">
      <Container >
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} sx={{ minHeight: 36 }}>
          <Box display={'flex'}>

            <SubMenus Menus={subMenus} />

          </Box>

          <TopRightTools Tools={tools} />

        </Stack>

        <Outlet context={[setTools]} />

      </Container>
    </Page>
  );
}
